 <!--
# -----------------------------------------------------------------------------
# Component: DefaultBranch.vue
# Author: antonio.ramirez@pst.sg
# Created Date: 28/Jun/2019
# Comments: Page for Selecting User Default Branch
# -----------------------------------------------------------------------------
-->
 <template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
      <v-toolbar-title>Select Branch </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <strong> Please select your user branch</strong>
    </v-card-text>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-autocomplete
              :items="branchesList"
              v-model="userDefaultBranch"
              :label="userDefaultBranchLabel"
              item-text="label"
              item-value="value"
              data-vv-name="userDefaultBranch"
              :data-vv-as="userDefaultBranchLabel"
              v-validate="'required'"
              :error-messages="errors.collect('userDefaultBranch')"
              clearable
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click.native="doContinueLogin">
        <span>Continue</span>
        <v-icon right>mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      branchesList: [],
      userDefaultBranch: '',
      userDefaultBranchLabel: 'User Branch'
    }
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    doContinueLogin() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('continueLogin', this.userDefaultBranch)
        }
      })
    }
  },
  computed: {
    initBranch() {
      return this.$store.state.commons.init
    }
  },
  watch: {
    initBranch: {
      handler: function (value) {
        if (value === 1) {
          this.getBranches('branchesList')
          this.userDefaultBranch = this.$store.getters.userDefBranch
        }
      }
    }
  },
  mixins: [commonAjaxMixin]
}
</script>
